import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { CENRejectOrderApiParameter, clearCart } from "@tCentro/Services/CENCartService";
import {
    chain,
    SendDataToApi,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/OrderApprovalDetails/Handlers/DeleteOrder";

type HandlerType = ApiHandlerDiscreteParameter<CENRejectOrderApiParameter & HasOnSuccess, CENRejectOrderApiParameter>;

const PopulateRemarkApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.apiParameter,
        remark: props.parameter.remark || "none",
    };
};

addToChainAfter(chain, PopulateApiParameter, PopulateRemarkApiParameter);

replaceInChain(chain, SendDataToApi, async props => {
    await clearCart(props.apiParameter as CENRejectOrderApiParameter);
});
